<script>
export default {
    name: 'IconConnexion'
}
</script>
<template>
    <svg
        class="base-icon icon-connexion"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M40.001 17.665C47.064 20.75 52 27.799 52 36c0 11.046-8.954 20-20 20s-20-8.954-20-20c0-8.201 4.936-15.25 12-18.336v6.846c-3.627 2.53-6 6.733-6 11.49 0 7.732 6.268 14 14 14s14-6.268 14-14c0-4.757-2.373-8.96-5.999-11.49v-6.845zM35 8v24h-6V8h6z"
            fill="currentColor"
            fill-rule="evenodd"
        />
    </svg>
</template>
